import { ChevronLeft, ChevronRight } from "lucide-react";

interface PaginationFooterProps {
  offset: number;
  limit: number;
  total: number;
  onPrev: () => void;
  onNext: () => void;
  /** Disable both controls, e.g. while a page/search fetch is in flight. */
  disabled?: boolean;
}

/**
 * Prev/Next controls plus a "showing X–Y of Z" label, shared by the
 * server-side paginated ordering and share list screens.
 */
export function PaginationFooter({
  offset,
  limit,
  total,
  onPrev,
  onNext,
  disabled,
}: PaginationFooterProps) {
  const from = total === 0 ? 0 : offset + 1;
  const to = Math.min(offset + limit, total);
  const atStart = offset <= 0;
  const atEnd = offset + limit >= total;

  return (
    <div className="border-wg-03 flex items-center justify-between gap-4 border-t px-5 py-3 text-sm">
      <span className="text-wg-06 tabular-nums">
        Showing {from}–{to} of {total}
      </span>
      <div className="flex items-center gap-2">
        <button
          type="button"
          onClick={onPrev}
          disabled={disabled || atStart}
          className="border-wg-04 text-wg-08 hover:border-wg-06 hover:bg-wg-01 inline-flex cursor-pointer items-center gap-1 rounded-full border px-3.5 py-1.5 text-xs font-semibold disabled:cursor-not-allowed disabled:opacity-40"
        >
          <ChevronLeft className="size-3.5" />
          Prev
        </button>
        <button
          type="button"
          onClick={onNext}
          disabled={disabled || atEnd}
          className="border-wg-04 text-wg-08 hover:border-wg-06 hover:bg-wg-01 inline-flex cursor-pointer items-center gap-1 rounded-full border px-3.5 py-1.5 text-xs font-semibold disabled:cursor-not-allowed disabled:opacity-40"
        >
          Next
          <ChevronRight className="size-3.5" />
        </button>
      </div>
    </div>
  );
}
